import { PricingDialogCommandHandler } from '@/services/pricing/commands/pricing-dialog.commands';
import { PricingDialogService, PricingDialogServiceImpl } from '@/services/pricing/pricing-dialog.service';
import { CommandContribution } from '@patsnap/tahiti-core';
import { type interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PlanListDialogCommandHandler } from '@/features/plg-plan/services/commands/plan-list-dialog.commands';
import { PaymentSuccessDialogCommandHandler } from '@/features/plg-plan/services/commands/payment-success-dialog.commands';
import { trialEndModule } from '@/features/trial-end';

/**
 * Pricing 相关服务的依赖注入模块
 */
export const pricingModule = (bind: interfaces.Bind) => {
    // 绑定 Pricing 对话框服务
    bind(PricingDialogService).to(PricingDialogServiceImpl);

    // 绑定命令处理器
    bind(CommandContribution).to(PricingDialogCommandHandler);

    // 绑定 PlanList 命令处理器
    bind(CommandContribution).to(PlanListDialogCommandHandler);

    // 绑定 PaymentSuccess 命令处理器
    bind(CommandContribution).to(PaymentSuccessDialogCommandHandler);

    // 绑定 TrialEnd 模块
    trialEndModule(bind);
};
